var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathroomWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.60614 62.35623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.35654,
    y: 0.55913,
    width: 2.14257,
    height: 61.45394,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31936,10.13051a5.06526,5.06526,0,1,0-5.0651-5.06525A5.06523,5.06523,0,0,0,14.31936,10.13051Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.57052,42.24694l.002,17.7184a2.38816,2.38816,0,1,1-4.77631,0l-.002-17.7184H2.46474L9.23722,18.7532H8.17273L4.18431,32.17362C3.235,35.10082-.78375,33.89834.13573,30.76393L4.564,16.1837a6.68937,6.68937,0,0,1,6.21726-4.61037h6.96829A6.91325,6.91325,0,0,1,24.015,16.1837l4.43018,14.566c.886,3.13269-3.10113,4.43018-4.05045,1.37656L20.4077,18.7532H19.25507l6.84514,23.49374H19.74309V59.98878a2.37818,2.37818,0,0,1-4.75631,0V42.24694Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.46608,11.55442a6.51075,6.51075,0,0,0-6.43057,6.62575V33.85381a2.2,2.2,0,1,0,4.39675,0V19.52188h1.0409V59.23369a2.92866,2.92866,0,1,0,5.855,0V35.98483h1.00839V59.23369a2.94428,2.94428,0,1,0,5.88707,0V19.52188h1.01652V33.85381a2.18611,2.18611,0,1,0,4.366,0V18.27393a6.60431,6.60431,0,0,0-6.50948-6.71247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.8084,
    cy: 5.06526,
    r: 5.06526,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroomWhite);
export default __webpack_public_path__ + "static/media/Bathroom_White.8114acac343672786b2e8413303e513e.svg";
export { ForwardRef as ReactComponent };